
import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import OverviewItem from '../../components/overview/OverviewItem.vue';
import BounceInTransition from '../../components/shared/BounceInTransition.vue';
import InfiniteScroll from '../../components/shared/InfiniteScroll.vue';
import {
    IAggregateResultHypermediaRepresentation,
    IAggregateResultItemHypermediaRepresentation
} from '../../shared/contracts/AggregateContract';
import { performance } from '../../shared/services/PerformanceService';
import { IAggregateState } from '../../store/contract';

const aggregateNamespace = 'aggregate';
const pageSize = 10;

@Component({
  components: {
    OverviewItem,
    BounceInTransition,
    InfiniteScroll
  }
})
export default class OverviewBase extends Vue {
  @State(aggregateNamespace) aggregateState: IAggregateState;

  protected itemsToShow: IAggregateResultItemHypermediaRepresentation[] = [];
  protected searchQuery: string = null;
  protected name: string = null;

  @Watch('searchQuery')
  onAnswerChanged(val: string) {
    this.itemsToShow = [];
    this.loadMore();
  }

  // Abstract functions

  protected get aggregate(): IAggregateResultHypermediaRepresentation {
    throw new Error('not implemented');
  }

  public goToDetails(id: string, name: string) {
    throw new Error('not implemented');
  }

  // Implemented functions

  created() {
    this.loadMore();
  }

  mounted() {
    const nameQuery = this.$route.query.name;
    this.name = nameQuery ? typeof nameQuery === 'string' ? nameQuery : nameQuery[0] : null;
    this.$nextTick(() => {
      performance.end(this.title);
    });
  }

  protected get title(): string {
    return 'Dashboard';
  }

  protected get placeholder(): string {
    return '';
  }

  protected get headerComponent(): any {
    return null;
  }

  protected get headerProps(): any {
    return {};
  }

  public loadMore(done?: () => void) {
    const numberItemsShowing = this.itemsToShow.length;
    if (numberItemsShowing < this.filteredItems.length) {
      this.itemsToShow.push(...this.filteredItems.slice(numberItemsShowing, numberItemsShowing + pageSize));
    }
    if (done) {
      done();
    }
  }

  private get filteredItems(): IAggregateResultItemHypermediaRepresentation[] {
    if (!this.searchQuery) {
      return this.aggregate.items;
    }
    return this.aggregate.items.filter((item: IAggregateResultItemHypermediaRepresentation) => {
      return item.itemName && item.itemName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1;
    });
  }
}
